<div class="modify-scope-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>

    <div class="restriction-name" *ngIf="data.restrictionName">
      <strong>Restriction:</strong> {{ data.restrictionName }}
    </div>

    <div class="options-container">
      <div class="option-card" *ngIf="data.showThisOccurrence !== false" (click)="onSelectScope('THIS_OCCURRENCE')">
        <mat-icon class="option-icon">event</mat-icon>
        <h3>Only This Occurrence</h3>
        <p>Apply the new date and time only to the occurrence on {{ selectedDateLabel }}. It becomes a separate one-time restriction; the rest of the series is unchanged.</p>
      </div>

      <div class="option-card" (click)="onSelectScope('FROM_SELECTED_DATE')">
        <mat-icon class="option-icon">update</mat-icon>
        <h3>From the Selected Date</h3>
        <p>Restart the series from {{ selectedDateLabel }} with the new settings. Earlier occurrences are unchanged.</p>
      </div>

      <div class="option-card" (click)="onSelectScope('ALL_OCCURRENCES')">
        <mat-icon class="option-icon">event_repeat</mat-icon>
        <h3>All Occurrences</h3>
        <p>Apply the changes to the whole series, keeping its original start date.</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</div>
